import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import './LiveCasinoThumbnail.css';
import { useThumbnailSize } from '../../../../hooks/use-thumbnail-size.hook';
import { useFitTextToRows } from '../../../../../../shared/src/hooks/use-fit-text-to-rows.hook';
import { Image } from '../../../../../../shared/src/components/Image';
import { CasinoThumbnailOverlayBasic } from '../../Casino/CasinoThumbnailOverlayBasic';
import { CasinoThumbnailOverlayStripsUI } from '../../Casino/CasinoThumbnailOverlayStripsUI';
import { CasinoThumbnailInit } from '../../Casino/CasinoThumbnailInit';

export const LiveCasinoThumbnail = ({
    name,
    images,
    badges,
    openGameHandler,
    isMobile = true,
    thumbnailSize: argumentThumbnailSize,
    liveCasinoState,
    id,
    imageType,
}) => {
    const [overlayActive, setOverlayActive] = useState(false);
    const {
        config: { showStripsGridUI },
        platformReady,
        areFavoritesEnabled,
    } = useSelector((state) => state.app);
    const { isLoggedIn } = useSelector((state) => state.player);
    const ctaTextRef = useRef();
    const thumbnailRef = useRef();
    const { thumbnailSize: calculatedThumbnailSize } = useThumbnailSize(thumbnailRef);
    const showFavorites = areFavoritesEnabled && platformReady && isLoggedIn;
    const thumbnailSize = argumentThumbnailSize || calculatedThumbnailSize;

    // adjust "Play game_name" text to 2 rows
    useFitTextToRows(
        ctaTextRef,
        2,
        [ctaTextRef, overlayActive, thumbnailSize],
    );

    const getThumbnailEventHandlers = () => {
        let eventHandlers = {
            onClick: openGameHandler,
        };

        // show and hide overlay on hover for desktop
        if (!isMobile) {
            eventHandlers = {
                onMouseEnter: () => { setOverlayActive(true); },
                onMouseLeave: () => { setOverlayActive(false); },
            };
        }

        return eventHandlers;
    };

    const className = classNames(
        'casino-thumbnail',
        `casino-thumbnail--${thumbnailSize}`,
        'live-casino-thumbnail',
        {
            'casino-thumbnail--strips-grid-ui': showStripsGridUI,
        },
    );

    return (
        <div
            className={className}
            ref={thumbnailRef}
            {...getThumbnailEventHandlers()}
        >
            <Image
                className="casino-thumbnail__img"
                images={images}
                alt={name}
                imageType={imageType}
            />

            {/*initial (rest) state*/}
            {!overlayActive && (badges.length > 0 || showFavorites) &&
                <CasinoThumbnailInit
                    gameId={id}
                    badges={badges}
                    showFavorites={showFavorites}
                    showStripsGridUI={showStripsGridUI}
                    extraClassName="live-casino-thumbnail__init"
                    gameSpecificFieldsInfo={liveCasinoState}
                />
            }

            {/*state on hover (or mobile first click)*/}
            {overlayActive
                && (
                    <>
                        {!showStripsGridUI && <CasinoThumbnailOverlayBasic
                            openGameHandler={openGameHandler}
                            showFavorites={showFavorites}
                            name={name}
                            ctaTextRef={ctaTextRef}
                            gameId={id}
                        />}

                        {showStripsGridUI && <CasinoThumbnailOverlayStripsUI
                            openGameHandler={openGameHandler}
                            showFavorites={showFavorites}
                            gameId={id}
                        />}
                    </>
                )
            }
        </div>
    );
};
